import cryptoJs from "crypto-js";
import { Buffer } from "buffer";

const cipherPassword = process.env.REACT_APP_ENCRYPTION_PASSWORD;

export const encryptAuthHeader = (authHeader) => {
  const cipheredAuthHeader = encryptCipher(authHeader)
  return Buffer.from(cipheredAuthHeader, 'utf8').toString('base64');
};
export const encryptCipher = (data) => {
  const returnData = cryptoJs.AES.encrypt(data, cipherPassword).toString();
  return returnData;
}
export const decryptAuthHeader = (authHeader) => {
  const header  = Buffer.from(authHeader, 'base64').toString('utf8')
  const decryptedAuthHeader = cryptoJs.AES.decrypt(header, cipherPassword);
  return JSON.parse(decryptedAuthHeader.toString(cryptoJs.enc.Utf8));
};